module.exports = __webpack_public_path__ + "img/datospersonales.eb1bd4c0.png";